import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    headerActionWrapper: {
        color: theme.palette.info.main,
        fontFamily: "Source Sans 3",
        fontWeight: 700,
        fontSize: 12,
        textTransform: "uppercase",
        display: "flex",
        alignItems: "center",
        gap: 6,
        cursor: "pointer",
        textDecorationLine: "underline",
    },
    headerActionWrapperDisabled: {
        color: theme.palette.info.main,
        boxShadow: "0px 2px 0px rgba(62, 93, 138, 0.2)",
        fontFamily: "Source Sans 3",
        fontWeight: 700,
        fontSize: 12,
        textTransform: "uppercase",
        display: "flex",
        alignItems: "center",
        gap: 6,
    },
}));
